import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const RAG_ABSOLUTE_PATH = "https://dialogue.kahun.com";
export const KAHUN_AVATAR_SRC = "/kahunIcon.svg";
export const USER_AVATAR_SRC = "/userIcon.svg";

export enum Colors {
  primary = "#5A52C3",
  secondary = "#8884A3",
  buttonColor1 = "#716E92",
  buttonColor2 = "#4B4074",
  textMain = "#243443",
  mainBackground = "#F7F7F9",
  lightBackground = "#F5F5FF",
  lightBackground2 = "#E6E5F5",
  borders = "#E1E1E1",
  sidebarBackground = "#F4F3F6",
}

export const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: Colors.primary,
        light: Colors.lightBackground,
      },
      secondary: {
        main: Colors.secondary,
        light: Colors.lightBackground2,
      },
      background: {
        default: Colors.mainBackground,
      },
      divider: Colors.borders,
      text: {
        primary: Colors.textMain,
      },
    },
    typography: {
      fontFamily: '"Inter", -apple-system, "Segoe UI", sans-serif',
      fontSize: 14,
      htmlFontSize: 14,
    },
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            color: Colors.primary,
            cursor: "pointer",
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: 14,
            lineHeight: 1.6,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: Colors.borders,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            gap: 12,
          },
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            minWidth: 0,
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            color: Colors.textMain,
            backgroundColor: "#FFFFFF",
            border: `1px solid #97979750`,
            padding: "10px",
            lineHeight: 1.2,
            margin: 0,
            whiteSpace: "pre-wrap",
            "& .medium-tooltip": {
              fontSize: "0.8rem",
            },
            "& .bigger-tooltip": {
              fontSize: "0.9rem",
            },
            "& .multiline-tooltip": {
              whiteSpace: "pre-wrap",
            },
            "& .md-tooltip": {
              fontSize: "0.8rem",
            },
            "& .md-tooltip p": {
              margin: 0,
            },
            "& .md-tooltip h1": {
              fontSize: "0.9rem",
              margin: "0 0 6px 0",
            },
            " & .md-tooltip h3, & .md-tooltip h2": {
              fontSize: "0.8rem",
              margin: "0 0 6px 0",
            },
            "& .rtl-tooltip": {
              direction: "rtl",
              textAlign: "right",
              display: "block",
            },
          },
          popper: {
            '&[data-popper-placement*="top"] .MuiTooltip-arrow': {
              margin: "0 0 -12px 0",
            },
            '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
              margin: "-12px 0 0 0",
            },
          },
          arrow: {
            color: "#FFFFFF",
            width: 20,
            height: 12,
            "&:before": {
              border: `1px solid #97979750`,
            },
          },
        },
      },
      MuiSnackbar: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent",
          },
        },
      },
      MuiSnackbarContent: {
        styleOverrides: {
          root: {
            backgroundColor: Colors.primary,
            color: "#FFFFFF",
            justifyContent: "center",
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          h1: {
            fontSize: "1.2rem",
            fontWeight: 600,
            margin: "0 0 10px 0",
            color: Colors.primary,
          },
          h2: {
            fontSize: "1rem",
            fontWeight: 600,
            margin: "0 0 8px 0",
          },
          h3: {
            fontSize: "0.9rem",
            fontWeight: 600,
            margin: "0 0 8px 0",
          },
          h4: {
            margin: "0 0 6px 0",
          },
          h5: {
            margin: "0 0 4px 0",
          },
        },
      },
    },
  }),
);
